export function getStateAbbreviation(states, stateName){
  if (stateName) {
    const state = states.find(state => state.name == stateName);
    if (state)
      return state.postal_abbreviation
  }
}